<template>
  <div class="w-3/6 px-12" >
      <div class="h-full bg-corange rounded-md p-4">
          <h1 class="text-cdark text-2xl pb-2">Box Plot Results</h1>
          <p class="text-cfontgrey">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Amet similique sed, cum molestiae culpa nemo quod rerum quia aliquam fugiat?</p>
      </div>
  </div>
</template>

<script>
export default {
    name: 'AtomBoxPlotInfo',
}
</script>

<style scoped>

</style>
